/**
 * Flex 레이아웃 공통 컴포넌트
 *
 * 반복되는 flex 컨테이너 패턴을 재사용 가능한 styled-component로 제공한다.
 */

import { styled, css } from 'styled-components';

// ─────────────────────────────────────────────────────────────
// Flex 컨테이너 컴포넌트
// ─────────────────────────────────────────────────────────────

/** 기본 flex 컨테이너 (align-items: center) */
export const FlexBox = styled.div`
  display: flex;
  align-items: center;
`;

/** space-between flex 컨테이너 */
export const FlexSBCBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

/** 세로 방향 flex 컨테이너 */
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

/** 가로·세로 모두 가운데 정렬 flex 컨테이너 */
export const FlexCenterBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** 왼쪽 정렬 flex 컨테이너 */
export const FlexStartBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

/** 오른쪽 정렬 flex 컨테이너 */
export const FlexEndBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

/** 가운데 정렬 세로 flex 컨테이너 */
export const FlexColumnCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/** gap을 지정할 수 있는 세로 flex 컨테이너 */
export const FlexColumnGap = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap = '8px' }) => gap};
`;

/** gap을 지정할 수 있는 가로 flex 컨테이너 */
export const FlexRowGap = styled.div<{ gap?: string }>`
  display: flex;
  align-items: center;
  gap: ${({ gap = '8px' }) => gap};
`;

/** 줄 바꿈 flex 컨테이너 */
export const FlexWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

// ─────────────────────────────────────────────────────────────
// Flex CSS 믹스인 (styled-components css 태그 리터럴)
// ─────────────────────────────────────────────────────────────

/** 가로·세로 모두 가운데 정렬 */
export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** space-between 가로 정렬 */
export const flexBetween = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

/** 세로 방향 flex */
export const flexColumn = css`
  display: flex;
  flex-direction: column;
`;

/** 세로 방향 + 가운데 정렬 */
export const flexColumnCenter = css`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/** 가로 방향 + 세로 가운데 정렬 */
export const flexRowCenter = css`
  display: flex;
  align-items: center;
`;
